import { encodeUnsupportedCharacters } from './replaceCharacter';

/**
 * Build a list-page URL with a pre-applied filter chip.
 *
 * Mirrors the URL format the grid's filtersButton emits and the
 * Grid.Managed `initialiseFilters` method parses
 * (see src/components/common/filter/filtersButton.jsx:184 and
 * src/components/common/grid/managed/index.jsx:155). The `[label]` segment
 * is what makes the chip render the human-readable label without an extra
 * lookup, so callers should always pass it.
 *
 * Example:
 *   buildFilteredListUrl('/campaigns', 'franchiseId', 42, 'Acme Series')
 *   => '/campaigns?franchiseId=42&franchiseId[label]=Acme%20Series'
 */
export const buildFilteredListUrl = (
  path: string,
  filterKey: string,
  id: number | string,
  label?: string | null
): string => {
  const params: string[] = [`${filterKey}=${encodeURIComponent(String(id))}`];
  if (label) {
    const sanitized = encodeUnsupportedCharacters(label);
    params.push(`${filterKey}[label]=${encodeURIComponent(sanitized)}`);
  }
  return `${path}?${params.join('&')}`;
};
